import { useCallback, useMemo } from 'react'

import { MultiSelectDynamic } from 'core-components/library/multiSelect'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

import styles from '../QBRDocumentsFilterArea.module.scss'

interface IQBRPartnerFilterProps {
  qbrDocumentsData: IQBRDocumentsListItem[]
  partnersValue: string[]
  onChangePartnersValue: (value: string[]) => void
}

export interface IParsedObject {
  PartnerID: string
  PartnerName: string
}

export const QBRPartnerFilter = ({
  qbrDocumentsData,
  partnersValue,
  onChangePartnersValue,
}: IQBRPartnerFilterProps) => {
  const partnersArray = qbrDocumentsData
    .map((values: IQBRDocumentsListItem) => {
      return values.PartnerIDs
    })
    .filter((value): value is string => value !== null)

  const parsedArray = partnersArray
    .map((values) => {
      return JSON.parse(values) as IParsedObject[]
    })
    .flat()

  const uniqueArray = parsedArray.reduce((acc, current) => {
    const newItem = acc.find((item: IParsedObject) => item.PartnerID === current.PartnerID)
    if (!newItem) {
      return acc.concat(current)
    } else {
      return acc
    }
  }, [] as IParsedObject[])

  const newArray = uniqueArray.map((el: IParsedObject) => ({
    value: el.PartnerID,
    label: el,
  }))

  const crud = useMemo(() => {
    return new Crud({
      fetcher: new Static(newArray),
      keyField: 'value',
      defaultSort: { field: 'value', dir: 'asc' },
      defaultPaging: { page: 0, pageSize: uniqueArray.length },
    })
  }, [newArray, uniqueArray])

  const onPartnersChange = useCallback(
    (value: string[]) => {
      onChangePartnersValue(value)
    },
    [onChangePartnersValue]
  )

  return (
    <div className={styles.filter}>
      <MultiSelectDynamic
        value={partnersValue}
        source={crud}
        label="Partners"
        caption="label"
        onChange={onPartnersChange}
        renderFunction={(item) => (
          <div>
            {item.label?.PartnerID} "{item.label?.PartnerName}"
          </div>
        )}
      />
    </div>
  )
}
